import { NgModule } from '@angular/core';
import { FiInactivityCountdownNotificationComponent } from './inactivity-countdown-notification.component';
import { CommonModule } from '@angular/common';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiInactivityCountdownNotificationService } from './inactivity-countdown-notification.service';

@NgModule({
    imports: [CommonModule, FiAppTextSharedModule],
    declarations: [FiInactivityCountdownNotificationComponent],
    exports: [FiInactivityCountdownNotificationComponent],
    providers: [FiInactivityCountdownNotificationService],
})
export class FiInactivityCountdownNotificationModule {}
